import e, { useState as t, useRef as r, useEffect as n } from "react";

function a(t) {
  return e.createElement("li", null, t.title);
}

export default function (a) {
  for (var i = a.activeTab, s = a.children, c = a.className, l = a.ulClassName, o = a.activityClassName, m = a.onClick, u = t(i ? Number(i) : 1), d = u[0], f = u[1], v = t({
    width: 0,
    left: "0"
  }), b = v[0], p = v[1], N = [], h = 0; h < s.length; h++) {
    N.push(r(""));
  }

  var E = function E(e) {
    void 0 === e && (e = d - 1), N[e] && N[e].current && p({
      width: N[e].current.clientWidth,
      left: N[e].current.offsetLeft + "px"
    });
  };

  return n(function () {
    function e() {
      E();
    }

    return E(), window.addEventListener("resize", e), function () {
      return window.removeEventListener("resize", e);
    };
  }, [d]), e.createElement("div", {
    className: "rb-tabs " + (c || "")
  }, e.createElement("div", {
    className: "rb-tabs-header"
  }, e.createElement("ul", {
    className: "rb-tabs-items " + (l || "")
  }, function (t) {
    return t.map(function (t, r) {
      return e.createElement("li", {
        ref: N[r],
        key: r,
        onClick: function onClick(e) {
          return t = e, f((n = r) + 1), void (void 0 !== m && m(t, n + 1));
          var t, n;
        },
        className: "rb-tabs-item " + (t.props.className ? t.props.className : "") + (d === r + 1 ? " active" : "")
      }, t.props.title);
    });
  }(s)), e.createElement("div", {
    style: {
      width: b.width + "px",
      left: b.left
    },
    className: "rb-tabs-active-item " + (o || "")
  })), e.createElement("div", {
    className: "rb-tabs-content"
  }, s.map(function (t, r) {
    return e.createElement("div", {
      className: "rb-tabs-content-item " + (d === r + 1 ? "show" : ""),
      key: r
    }, t.props.children);
  })));
}
export { a as Tab };